import axios from "axios";
import * as d3 from "d3";
import {colonAnnotation, colourScheme, numberFormat, percentageSymbol,createAxis, responsivefy,wraps} from "@/common/functions";

export default function (chart, divId, vizName, filterParam) {
    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)
    console.log("kiran");
    console.log("chart", chart);

    axios.post(url, filterParam).then(res => {
        let data = res.data;
        console.log("data::", data);
        console.log('numsystem', chart.numsystem);
        console.log("numdisplaytype", chart.numdisplaytype);
        console.log("color", chart.colourscheme1);
        console.log(chart.x1MetricUnit);
        console.log("break line",chart.x1AxisLabelCharLimitsJson);
        // append the svg object to the body of the page
        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId)
            .append('svg')
            .attr('width', chart.width - chart.margin.left + chart.margin.right)
            .attr('height', chart.height + chart.margin.top + chart.margin.bottom)
            .call(responsivefy)
            .append('g')
            .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

        // Build scales x-axis and y-axis
        // var dataValue=data.map((d) => {
        //     return d.dim1_name
        // }).sort(d3.ascending)
        // var dataValue1=data.map((d) => {
        //     return d.dim2_name
        // }).sort(d3.ascending)
        // var rabge=;
        // var range1=[chart.height,0];
        // Build scales x-axis and y-axis
        var x1Scale = createAxis(chart.x1D3ScaleType).domain(data.map((d) => {
            return d.dim1_name
        }).sort(d3.ascending)).range([0,chart.width]).padding(0.02);
        var y1Scale = createAxis(chart.y1D3ScaleType).domain(data.map((d) => {
            return d.dim2_name
        }).sort(d3.ascending)).range([chart.height,0]).padding(0.01);
        //calling scales
        var x1AxisLabel = d3.axisBottom().scale(x1Scale)
        var y1AxisLabel = d3.axisLeft().scale(y1Scale)

        // Build color scales
        var myColor1 = colourScheme(chart.colourscheme1);
        var myColor = d3.interpolateYlOrRd;

        console.log("mycolor", myColor);
        console.log("mycolor1", myColor1);

        var metric1ColorScale = d3.scaleSequential(myColor1)
            .domain([d3.min(data, (d) => d.metric1), d3.max(data, (d) => d.metric1)]);

        // Labels of row and columns
        // x1Scale.domain(data.map((d) => {
        //     return d.dim1_name
        // }).sort(d3.ascending))
        // y1Scale.domain(data.map((d) => {
        //     return d.dim2_name
        // }).sort(d3.descending))
         const xAxisWidth = chart.width;

        const jsonData = chart.x1AxisLabelCharLimitsJson;
        console.log("json data",jsonData);
        // Extract values into separate variables
        const charecter = jsonData.break.value1;
        const charecter1 = jsonData.break.value2;
        const value2RegExp = new RegExp(charecter1.slice(1, -1));
        //const splitRegex = /( |,|_|(?=[A-Z]))/
        console.log("charecter",charecter);
        // console.log("splitbox",splitRegex);
        console.log(value2RegExp);
        // const splitRegex = /( |,|_|(?=[A-Z]))/;
        //  console.log("x1AxisLabelCharLimitsJson",chart.x1AxisLabelCharLimitsJson);
        //for an x axis
        svg.append('g')
            .attr('class', 'x axis')
            .attr('transform', 'translate(0,' + chart.height + ')')
            .call(x1AxisLabel);
        svg.selectAll('.x.axis .tick line')  // Select tick lines for x-axis
            .attr('transform', `translate(${xAxisWidth / 16.02}, 0)`)
            .style('stroke', 'black')  // Add border color
            .style('stroke-width', 0.4);  // Set border width
        svg.selectAll('.x.axis .tick text')
            // .style('text-anchor', 'end') // Adjust text-anchor to 'end'
            .attr('dy', '.5em') // Adjust vertical spacing
            //.attr('transform', 'translate(0, 0) rotate(0)') // Translate the text to the right by 10 units
            .style('font-size',  '12px')
            .call(wraps, charecter, value2RegExp);


        //.call(wraps, x1Scale.bandwidth()); // Set font-size here
        svg.selectAll('.x.axis .tick text tspan')  // Select all tspan elements within the x-axis ticks
            // .style('font-weight', 'bold')
            // .style('color', 'red')
            .attr('text-anchor', 'middle')
            .attr('dx', '0px');  // Add a CSS style, you can customize this as needed
        // Append a vertical line after each x-axis tick
        svg.selectAll('.x.axis .tick')
            .append('line')
            .attr('class', 'x-axis-line')
            .attr('x1', 62) // Adjust the horizontal position of the line
            .attr('y1', -chart.height) // Reverse the direction by changing y1
            .attr('x2', 62) // Adjust the horizontal position of the line
            .attr('y2', 0) // Reverse the direction by changing y2
            .style('stroke', 'black') // Adjust the color of the line
            .style('stroke-width', 0.4);

        //for an y axis
        svg.append('g')
            .attr('class', 'y axis')
            .call(y1AxisLabel);
        svg.selectAll('.y.axis .tick line')  // Select tick lines for x-axis
            .attr('transform', `translate(0, -16)`)  // Move to the end of the x-axis
            .style('stroke', 'black')  // Add border color
            .style('stroke-width', 1);  // Set border width
        svg.selectAll('.y.axis .tick text')
            .style('text-anchor', 'end') // Adjust text-anchor to 'start'
            //.attr('dx', '1em') // Adjust horizontal spacing
            // .attr('dy', '0.0em') // Set dy to 0 for no vertical spacing
            .attr('transform', 'translate(-6, -8)') // Rotate the labels for better visibility
            .style('font-size', '12px')
            .call(wraps, charecter, value2RegExp);
        //.call(wraps, y1Scale.bandwidth()+chart.margin.bottom); // Set font-size here

        svg.selectAll('.y.axis .tick text tspan')
            .attr('text-anchor', 'end');


        svg.selectAll('.y.axis .tick')
            .append('line')
            .attr('class', 'y-axis-line')
            .attr('x1', 0) // No horizontal offset for y-axis lines
            .attr('y1', -16) // Adjust the vertical position of the line
            .attr('x2', chart.width) // Adjust the horizontal position of the line
            .attr('y2', -16) // No vertical offset for y-axis lines
            .style('stroke', 'black') // Adjust the color of the line
            .style('stroke-width', 0.4); // Set border width

        svg.append('text')
            .attr('x', (chart.width / 3))
            .attr('y', chart.height + (chart.margin.bottom - 20))
            .text(chart.x1AxisDisplayName)
            .style('font-size', chart.axisFontSize + 'px');

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left)
            .attr('x', 0 - (chart.height / 2))
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .text(chart.y1AxisDisplayName)
            .style('font-size', chart.axisFontSize + 'px');

        d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        var div = d3.select(divId).append('div').attr('class', 'tooltip')
            .attr('style', 'position: absolute; opacity: 0;')

        // add the squares
        var squares = svg.selectAll()
            .data(data, (d) => d.dim1_name + ':' + d.dim2_name)
            .enter()
            .append('g');

        // add rectangles
        squares.append('rect')
            .attr('x', (d) => x1Scale(d.dim1_name))
            .attr('y', (d) => y1Scale(d.dim2_name))
            .attr('width', x1Scale.bandwidth())
            .attr('height', y1Scale.bandwidth())
            .style('fill', (d) => metric1ColorScale(d.metric1))
            .style('stroke', 'black') // Add border color
            .style('stroke-width', 0.1) // Set border width
            .on("mousemove", function (d) {
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(chart.x1MetricTooltip + colonAnnotation + d.dim1_name
                    + '<br>' + chart.x2MetricTooltip + colonAnnotation + d.dim2_name
                    + '<br>' + chart.y1MetricTooltip + colonAnnotation + numberFormat(d.metric1))
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            .on("mouseout", function () {
                div.transition().style("opacity", 0)
            });

        // add text on rect
        squares.append('text')
            .attr('x', (d) => x1Scale(d.dim1_name) + x1Scale.bandwidth() / 2)
            .attr('y', (d) => y1Scale(d.dim2_name) + y1Scale.bandwidth() / 2)
            .attr('dy', '0.35em') // Adjust vertical alignment
            .attr('text-anchor', 'middle') // Center the text
            .style('fill', chart.axisFontColor) // Set the text color
            .style('font-size', chart.axisLabelFontSize + 'px') // Set the font size
            .text((d) => numberFormat(d.metric1) + percentageSymbol(chart.x1MetricUnit))

    })
}